import { createOrthoJob } from "features/pubsub/entityActions/jobs/ortho"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { setOrthoOverlapLayer } from "./OrthomosaicSlice"
import { OrthoProcessingMode } from "@nova/constants"
import { selectActiveLayerId } from "panels/content/side-panel/slice.new"

export const useProcessing = () => {
    const dispatch = useAppDispatch()
    const activeLayerId = useAppSelector(selectActiveLayerId)

    const beginOrtho = async (mode?: OrthoProcessingMode, imageCount?: number) => {
        if (!activeLayerId) return
        dispatch(
            createOrthoJob({
                data: { processingMode: mode ?? OrthoProcessingMode.General },
                context: { flightId: activeLayerId, imageCount },
            })
        )

        dispatch(setOrthoOverlapLayer({ id: activeLayerId, active: false }))
    }

    const canProcessPlugin = (baseRequirements: boolean) => baseRequirements

    return { canProcessPlugin, processCallback: beginOrtho, dependencies: [dispatch] }
}
